import {Component, Input, OnInit} from '@angular/core';
import {ContentListSource} from '../content-list-source';

@Component({
  selector: 'app-list-pager',
  templateUrl: './list-pager.component.html',
  styleUrls: ['./list-pager.component.scss']
})
export class ListPagerComponent implements OnInit {

  @Input() contentListSource: ContentListSource;

  endPage;
  maxPage;
  private startPage = 1;
  private timeoutPromise;
  private lastPage = 1;
  private artifactLowerEl;

  constructor() {
  }

  ngOnInit() {
    this.artifactLowerEl = document.getElementById('artifactLower');
    this.setPageInfo();
  }

  setPage(page) {
    this.contentListSource.page = page;
    this.listPageChange();
  }

  prevPage() {
    if (this.contentListSource.page > 1) {
      this.setPage(this.contentListSource.page - 1);
    }
  }

  nextPage() {
    if (this.contentListSource.page < this.maxPage) {
      this.setPage(this.contentListSource.page + 1);
    }
  }

  setLastPage() {
    this.setPage(this.maxPage);
  }

  listPageChange() {
    if (this.timeoutPromise) {
      clearTimeout(this.timeoutPromise);
    }
    this.timeoutPromise = setTimeout(() => {
      if (this.lastPage !== this.contentListSource.page) {
        const page = this.getListPage(this.contentListSource.page);
        if (page) {
          this.lastPage = this.contentListSource.page;
          if (!this.contentListSource.displayAll) {
            this.scrollToPager(500);
          }
        }
      }
    }, 500);
  }

  getPages() {
    let t;
    const res = [];
    for (t = this.startPage; t < this.endPage + 1; t++) {
      res.push(t);
    }
    return res;
  }

  toggleDisplayAll() {
    this.contentListSource.displayAll = !this.contentListSource.displayAll;
    if (!this.contentListSource.displayAll) {
      this.scrollToPager(500);
    }
    if (this.contentListSource.page !== 1) {
      this.setPage(1);
    } else {
    }
  }

  private getListPage(value) {
    let page, res;
    if (!isNaN(value)) {
      page = Number(value);
      if (page > 0 && page <= this.maxPage) {
        res = page;
      }
    }
    return res;
  }

  private scrollToPager(timeOut) {
    if (this.artifactLowerEl) {
      setTimeout(() => {
        const lowerPos = this.artifactLowerEl.offsetTop + 210;

        if (window.pageYOffset > lowerPos) {
          // const divPosition = this.artifactLowerEl.offsetTop;
          // const container = angular.element(
          //   document.getElementsByTagName(
          //     'body'));
          // $document.duScrollToElement(
          //   container, divPosition, 100);
        }
      }, timeOut);
    }
  }

  private setPageInfo() {
    this.maxPage = Math.ceil(this.contentListSource.items.length / this.contentListSource.maxRows);
    if (this.maxPage <= 6) {
      // Less than 6 total pages so show all
      this.startPage = 1;
      if (this.maxPage === 0) {
        this.maxPage = 1;
      }
      this.endPage = this.maxPage;
    } else {
      // More than 6 total pages: calculate start and end.
      if (this.contentListSource.page <= 4) {
        this.startPage = 1;
        this.endPage = 6;
      } else if (this.contentListSource.page + 2 >= this.maxPage) {
        this.startPage = this.maxPage - 5;
        this.endPage = this.maxPage;
      } else {
        this.startPage = this.contentListSource.page - 3;
        this.endPage = this.contentListSource.page + 3;
      }
    }
  }

}
